/* eslint-disable max-len */
import { message } from 'antd';
import { behaviourLabelsSection, locationDetailsSection, stopDetailsSection } from './eventInfoSections';

function prepareStreet(place) {
  if (!place) {
    return '';
  }
  return [place.street, place.houseNumber].filter((v) => v).join(' ');
}

export default ({
  sequence, timeSlot, place, position, type, behaviourTags = [], composite = behaviourTags.length > 1, behaviourGlyphTag,
}, t) => {
  const from = timeSlot.startMoment;
  const to = timeSlot.endMoment;
  window.copyAndNotify = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => message.success(t('COMMON.COPIED_TO_CLIPBOARD')));
  };

  const location = {
    ...place,
    position: {
      latitude: position.lat,
      longitude: position.lng,
    },
    countryCode: place?.country,
    street: `${prepareStreet(place)} ${place?.localNumber || ''}`,
  };

  return '<div class="H_bubble_root">'
    + '  <div class="H_bubble_wrapper">'
    + '    <div class="H_bubble_content">'
    + '      <div class="H_bubble_header">'
    + '        <span class="H_bubble_header--title">'
    + `          ${t(`ORDER.STOP_TYPES.${type}`)}`
    + '        </span>'
    + '      </div>'
    + '      <div class="horizontal-line"></div>'
    + `      ${stopDetailsSection(t, {
      from,
      to,
      sequence,
      // Undefined for an untagged or operational stop, which keeps the existing glyph.
      type,
      behaviourTag: behaviourGlyphTag,
      // Driven by the full recognised set (isCompositeBehaviour) via the creator, not by the
      // display-only chip list, so the ring matches the map marker for e.g. {OPERATIONAL, SERVICE}.
      composite,
    })}`
    // Deliberately unindented: this collapses to '' for an untagged stop, and a padded template
    // would leave stray whitespace behind, so the bubble markup would no longer be byte-identical.
    + `${behaviourLabelsSection(t, behaviourTags)}`
    + `      ${locationDetailsSection(t, { location })}`
    + '    </div>'
    + '    <div class="triangle-with-shadow"></div>'
    + '  </div>'
    + '</div>';
};
